// import { Container, FullWidthComponent } from "../../base/layout"
import { useState, useEffect } from "react"
import classNames from "classnames"
import { usePropsObject } from "@/lib/contexts/appContext"
import { themePlateColor, themeAccentTextColor } from "@/lib/helpers/utils"
import Button from "@/common/button/button"
import Block from "@/components/wrappers/block"
import styles from "./countdown-timer.module.css"

export default function CountdownTimer({ block }) {
  const { heading, paragraph, hasSidebar, button } = block.attrs
  const countDownDate = new Date(block.attrs.date).getTime()
  const [diff, setDiff] = useState(countDownDate - new Date().getTime())
  const { theme } = usePropsObject()
  useEffect(() => {
    const interval = setInterval(() => {
      setDiff(countDownDate - new Date().getTime())
    }, 1000)

    return () => clearInterval(interval)
  }, [countDownDate])

  const getTimeLeft = () => {
    const days = Math.floor(diff / (1000 * 60 * 60 * 24))
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    return [days, hours, minutes, seconds]
  }

  const [days, hours, minutes, seconds] = getTimeLeft()

  const parts = [
    {
      display: days,
      value: days,
      label: days === 1 ? "Dag" : "Dagar",
      keepZero: false
    },
    {
      display: ("0" + hours).slice(-2),
      value: hours,
      label: hours === 1 ? "Timme" : "Timmar",
      keepZero: true
    },
    {
      display: ("0" + minutes).slice(-2),
      value: minutes,
      label: minutes === 1 ? "Minut" : "Minuter",
      keepZero: true
    },
    {
      display: ("0" + seconds).slice(-2),
      value: seconds,
      label: "Sekunder",
      keepZero: true
    }
  ]
    .filter((part) => part.keepZero || part.display !== 0)
    .flatMap((part) => [{ display: false }, part])
    .slice(1)

  let plateColor = "bg-white"
  let digitColor = "text-green-100"
  let textColor = "text-black-100"

  if (theme) {
    plateColor = theme.plateColor
      ? themePlateColor(theme.plateColor)
      : plateColor
    digitColor = theme.accentColor
      ? themeAccentTextColor(theme.accentColor)
      : digitColor
    textColor = theme?.txtColor === "white" ? "text-white" : textColor
  }

  const checkLeft = parts.filter(
    (part) => part.label !== undefined && part.value > 0
  )

  if (checkLeft.length === 0) {
    return null
  }

  return (
    <Block
      block={block}
      width="full"
      className={classNames(["text-center", textColor])}>
      <div className={classNames(plateColor, "px-8 pt-6 pb-8")}>
        <h2 className={classNames(["bold", { "mb-1": !paragraph }])}>
          {heading}
        </h2>
        {paragraph && (
          <p className="pt-1.5 pb-2 lg:text-lg mx-auto block max-w-4xl">
            {paragraph}
          </p>
        )}
        <div className="flex justify-center max-w-4xl mx-auto">
          {parts.map((part, index) => {
            if (!part.display) {
              return (
                <div
                  key={`item-${index}`}
                  className={classNames([
                    digitColor,
                    hasSidebar ? styles.colonNarrow : styles.colon
                  ])}>
                  :
                </div>
              )
            }

            return (
              <div key={`item-${index}`} className={styles.wrapper}>
                <span
                  suppressHydrationWarning
                  className={classNames([
                    digitColor,
                    hasSidebar ? styles.digitNarrow : styles.digit
                  ])}>
                  {part.display}
                </span>
                {part.label}
              </div>
            )
          })}
        </div>
        {button && (
          <div className="mt-4 overflow-auto">
            <Button
              theme={button?.theme ?? "lime"}
              href={button.url}
              target={button.target}
              className="inline-block"
              ariaLabel={button.label}
              tagName="a">
              {button.label}
            </Button>
          </div>
        )}
      </div>
    </Block>
  )
}
